export default class LocaleService {
  public static localeSwedish = 'sv';
  public static localeEnglish = 'en-US';

  public static getLocale(): string {
    const hrefString = window.location.href;
    if (hrefString.indexOf('/en/') !== -1) return this.localeEnglish;
    return this.localeSwedish;
  }
}
